// Builds the URL for one page of the Spaces menu's Workspaces or Sharedspaces list.
export function spacesPageUrl(baseUrl: string, page: number, query: string): string {
  const params = new URLSearchParams({ page: String(page) });
  const trimmed = query.trim();
  if (trimmed) params.set('q', trimmed);

  return `${baseUrl}?${params.toString()}`;
}

// Whether a list scrolled this far is close enough to its end to fetch the next page.
export function nearListEnd(
  scrollTop: number,
  clientHeight: number,
  scrollHeight: number,
  threshold = 40,
): boolean {
  return scrollTop + clientHeight >= scrollHeight - threshold;
}
